
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/webdav",
      function () {
        return require("private-next-pages/destinations/webdav.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/webdav"])
      });
    }
  